export const options = [
    { value: "en", label: "English" },
    { value: "fr", label: "French" },
    { value: "ar", label: "Arabic" },
    { value: "am", label: "Amharic" },
    { value: "ti", label: "Tigrinya" },
    { value: "om", label: "Oromo" },
    { value: "he", label: "Hebrew" },
    { value: "so", label: "Somali" }
];